import { Link } from 'react-router-dom';
// import AlaramIcon from '../icon/AlaramIcon';

import { useUserInfo } from '#providers/UserInfo';

import Profile from 'src/r_page/main/profile';
import ChatIcon from 'src/r_page/main/icon/ChatIcon';
import Fibud_Logo from 'src/r_page/main/icon/Fibud_Logo';
import UnLoginProfile from '../profile/unLoginProfile';

const Header = () => {
  const { isLogIn } = useUserInfo();
  return (
    <div className="flex flex-col gap-[12.5px] bg-[#24222A] p-20 py-16 rounded-b-[20px] ">
      <div className="h-[44px] items-center flex justify-between">
        <Fibud_Logo />
        <div className="flex items-center gap-16">
          <Link to="/chat">
            <ChatIcon />
          </Link>
          {/* <AlaramIcon /> */}
        </div>
      </div>
      {isLogIn ? <Profile /> : <UnLoginProfile />}
    </div>
  );
};

export default Header;
